import { LogOut } from 'lucide-react';
import TrackedButton from 'src/components/tracked/tracked-button';
import { handleMutationError } from 'src/utils/handle-mutation-error';

import { CurrentUserQuery } from '@savvy/deprecated-shared/api/user-api';
import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { loggedInAsAdvisorID, removeLoggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';
import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';
import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { STOP_IMPERSONATING_USER } from '../logout-as-button';

type DashboardSidebarLogOutButtonProps = {
  readonly onLogOut?: () => void;
  readonly fullWidth?: boolean;
};

function DashboardSidebarLogOutButton({ onLogOut, fullWidth }: DashboardSidebarLogOutButtonProps) {
  const { logout, user, update } = useAuth();

  const { data: newCurrentUserData, refetch } = useQueryWithErrorLogging(CurrentUserQuery);

  const [stopImpersonatingUser] = useMutationWithErrorLogging(STOP_IMPERSONATING_USER);

  const isAdvisorLoggedInAsClient = !!loggedInAsAdvisorID();

  const handleLogout = async (): Promise<void> => {
    if (isAdvisorLoggedInAsClient) {
      try {
        await stopImpersonatingUser({ variables: { input: {} } });
        await refetch();
        update({ ...user, newCurrentUserData });
      } catch (err) {
        console.error(err);
      }
      removeLoggedInAsAdvisorID();
    }
    try {
      if (onLogOut) onLogOut();
      await logout();
      window.location.href = '/login';
    } catch (err) {
      console.error(err);
      handleMutationError(err, 'Unable to logout.');
    }
  };

  return (
    <TrackedButton
      elementName="dashboard-sidebar-log-out-button"
      icon={<LogOut />}
      iconPosition="left"
      aria-label="log out"
      variant="ghost"
      size="sm"
      className={fullWidth ? 'w-full justify-start text-foreground' : 'justify-start text-foreground'}
      onClick={() => {
        handleLogout();
      }}
    >
      Log out
    </TrackedButton>
  );
}

export default DashboardSidebarLogOutButton;
